// eslint-disable-next-line import/prefer-default-export
export const MODAL_TYPE = {
    LOGIN: 'login',
    SIGNUP: 'signup',
};



// WEBPACK FOOTER //
// /src/js/common/bookmakersListPopover/bookmakersButtonsPopovers.constants.js